import type {
  PaymentRecord,
  PaymentSource,
  PlatformPaymentRow,
  SyncStripeResult,
} from "@lumora/bridge";
import { formatUsd } from "@lumora/core";

export const PAYMENT_COLUMNS = [
  "When",
  "Site",
  "Amount",
  "Source",
  "Kind",
  "Method",
  "Note",
  "Stripe invoice",
];

export const SITE_PAYMENT_COLUMNS = [
  "Amount",
  "Source",
  "Method",
  "Kind",
  "Note",
  "Stripe invoice",
  "When",
];

export function sourceLabel(source: PaymentSource | undefined): string {
  return source === "stripe" ? "Stripe" : "Offline";
}

/** Date input (YYYY-MM-DD) -> RFC3339 bound; empty/invalid -> undefined. */
export function dateBound(day: string, end: boolean): string | undefined {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return undefined;
  return `${day}T${end ? "23:59:59" : "00:00:00"}Z`;
}

export function platformPaymentRows(rows: PlatformPaymentRow[]): string[][] {
  return rows.map((p) => [
    new Date(p.createdAt).toLocaleString(),
    p.siteName || p.tenantSlug,
    formatUsd(p.amountCents),
    sourceLabel(p.source),
    p.kind,
    p.method,
    p.note || "—",
    p.stripeInvoiceId || "—",
  ]);
}

/** Per-site table rows (SiteBackendPage) including the source column. */
export function sitePaymentRows(payments: PaymentRecord[]): string[][] {
  return payments.map((p) => [
    formatUsd(p.amountCents),
    sourceLabel(p.source),
    p.method,
    p.kind,
    p.note || "—",
    p.stripeInvoiceId || "—",
    new Date(p.createdAt).toLocaleString(),
  ]);
}

export function syncSummary(r: SyncStripeResult): string {
  return `Stripe sync done: ${r.imported} imported, ${r.skipped} skipped, ${r.unmatched} unmatched.`;
}
